<script lang="ts">
    let className = ''
    export { className as class }
    export let gapRow = '12px'
    export let gapCol = '12px'
    export let grow = true
</script>

<div class="z-container {className}" style="row-gap:{gapRow};column-gap:{gapCol};">
    <slot></slot>
</div>

<style>
    /* CSS Grid em vez de flex-wrap: o grid-column:span N de cada .z-col_w-N (ver css_z.css) já é
       naturalmente "gap-aware" (1fr divide o espaço que sobra DEPOIS de descontar os gaps), então
       nenhum ajuste manual de largura é necessário, e duas linhas com números diferentes de
       colunas alinham a borda direita sozinhas. O zinput-break força a quebra de linha via
       seletor de irmão adjacente (também em css_z.css) sem nunca ocupar uma linha própria do
       grid — então nunca duplica o row-gap, e não precisa de margem (nem JS) em lugar nenhum. */
    .z-container {
        display: grid;
        grid-template-columns: repeat(12, 1fr);
        width: 100%;
    }
    .z-container-col {
    }
    /* a linha (.z-container-row) se estiliza no próprio z-container-row.svelte: aqui o seletor
       nunca chegava a valer, porque o elemento não é desenhado por este componente */

    .z-container *:first-child.zinput_title {
        margin-top: 0px;
    }
</style>
